import React from "react";
import {
  RopeDetailModalKeyClass,
  RopeDetailModalKeyWidth,
  RopeDetailModalWidth,
  RopeLog
} from "../../types/Rope";
import { Modal, Table } from "antd";
import { formatDateTime } from "../../utils/formatDateTime";
import { Link } from "react-router-dom";

type RopeViewLogRecordModalProps = {
  modalState: boolean;
  closeModal: () => void;
  record: RopeLog | null;
};

const RopeViewLogRecordModal = (props: RopeViewLogRecordModalProps) => {
  const columns = [
    {
      title: "Detail",
      key: "k",
      className: RopeDetailModalKeyClass,
      dataIndex: "k",
      width: RopeDetailModalKeyWidth
    },
    {
      title: "Text",
      key: "v",
      render: (text, row) => {
        switch (row.k) {
          case "Created By":
            return row.v && props.record ? (
              <Link to={`/employees/${props.record.createdById}`}>{row.v}</Link>
            ) : (
              ""
            );
          case "Created At":
            return row.v ? formatDateTime(row.v) : "";
          default:
            return row.v;
        }
      }
    }
  ];
  let data = [{}];

  if (props.record) {
    data = [
      {
        k: "Log ID",
        v: props.record.id
      },
      { k: "Message", v: props.record.message },
      { k: "Project Information", v: props.record.description },
      { k: "File Name", v: props.record.fileName },
      { k: "Created At", v: props.record.createdAt },
      { k: "Created By", v: props.record.createdBy }
    ];
  }

  return (
    <Modal
      title={"View Log Record"}
      visible={props.modalState}
      onCancel={props.closeModal}
      footer={null}
      width={RopeDetailModalWidth}
    >
      <Table
        pagination={false}
        showHeader={false}
        columns={columns}
        dataSource={data}
        rowKey="k"
      />
    </Modal>
  );
};

export default RopeViewLogRecordModal;
